// Deep links to a family's entered-feis page (/edit-feis/:name?id=<event>),
// emailed in the Wednesday "print your number cards" reminder (backend
// helpers/feisReminderEmail.js, Devin 2026-11-04). A logged-out visit or an
// ended session goes to the parent login and comes back here afterwards.
// Modelled on PaymentRequest/payLink.js: only a rebuilt /edit-feis path with a
// 24-hex event id is ever remembered or honoured, so the stored value can't
// become an open redirect.
const KEY = "entryReturnPath";
const ENTRY_PATH = /^\/edit-feis\/([^/?#]+)\/?$/;
const EVENT_ID = /^[a-f0-9]{24}$/;

// The normalised path ("/edit-feis/<name>?id=<id>"), or null when it isn't one.
export function entryLink(pathname, search) {
  const m = ENTRY_PATH.exec(String(pathname || ""));
  if (!m) return null;
  let id = null;
  try {
    id = new URLSearchParams(String(search || "")).get("id");
  } catch (e) {
    return null;
  }
  if (!id || !EVENT_ID.test(id)) return null;
  return `/edit-feis/${m[1]}?id=${id}`;
}

export const isEntryLink = (pathname, search) => entryLink(pathname, search) !== null;

export function rememberEntryLink(pathname, search) {
  const path = entryLink(pathname, search);
  if (!path) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    /* storage unavailable: the family opens the emailed link again */
  }
}

// Read once and clear; returns null unless it is an entered-feis path.
export function takeEntryReturnPath() {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch (e) {
    return null;
  }
  if (!path) return null;
  const [pathname, query] = path.split("?");
  return entryLink(pathname, query ? `?${query}` : "");
}

// On the entered-feis page a 401 means the stored session no longer works:
// log in again and come back here.
export function entryLinkSessionEnded(status, pathname, search) {
  return status === 401 && isEntryLink(pathname, search);
}
